import React, { useState, useMemo, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { VerticalStepper } from '../components/common/vertical-stepper';
import { CheckoutForm } from '../checkout-form/checkout-form';
import { PAYMENT_METHOD_LABELS, ACH_PAYMENT_TAB, CREDIT_CARD_TAB } from '../checkout-form/checkout-constants';
import { ErrorModal } from '../pages/Error';
import { strRegistrationApiSender } from '../utils/str-registration-api-sender';

export function PaymentForm(props) {
  const { setPaymentData, licenseFeeInfo, formValues, businessInfo, resetFlow } = props;

  const [activePaymentMethodTab, setActivePaymentMethodTab] = useState(ACH_PAYMENT_TAB);
  const [isPaymentError, setIsPaymentError] = useState(false);
  const [paymentErrorMessage, setPaymentErrorMessage] = useState('');

  const history = useHistory();

  const checkoutDetails = useMemo(() => {
    const feeLabel = activePaymentMethodTab === CREDIT_CARD_TAB ?
      PAYMENT_METHOD_LABELS.cc : PAYMENT_METHOD_LABELS.ach;
    const feeValue = activePaymentMethodTab === CREDIT_CARD_TAB ? licenseFeeInfo.ccFee : licenseFeeInfo.achFee;

    const detailsByTier = {
      TIER1: [{ label: 'Total Gross Revenues', value: licenseFeeInfo.summary.taxableReceipts }],
    };

    const tierDetails = detailsByTier[businessInfo?.extras?.tier] || [];

    return [
      { label: 'Business Name', value: businessInfo.registrantName },
      ...tierDetails,
      { label: 'Assessment', value: licenseFeeInfo.summary.assessment },
      { label: 'Interest', value: licenseFeeInfo.summary.accruedInterest },
      { label: 'Penalties', value: licenseFeeInfo.summary.latePenalties },
      {
        label: feeLabel,
        value: feeValue,
      },
      { label: 'License Fee', value: licenseFeeInfo.summary.licenseFee },
    ];
  }, [licenseFeeInfo, formValues, activePaymentMethodTab]);

  const paymentPayload = {
    signatory: formValues.signatory,
    paymentId: licenseFeeInfo.paymentId,
    email: formValues.ownerEmail,
    phone: formValues.ownerPhone,
    title: formValues.ownerTitle
  };

  // Resets modal related state
  const handleModalClose = useCallback(() => {
    setIsPaymentError(false);
    setPaymentErrorMessage('');
  }, [setIsPaymentError, setPaymentErrorMessage]);

  const handleSuccessfulPayment = useCallback(() => {
    resetFlow();
    history.push('/success');
  }, [history, resetFlow]);

  const handleSuccess = useCallback(async () => {
    const { data } = await strRegistrationApiSender.get(`/checkPayment/${licenseFeeInfo.paymentId}`);
    setPaymentData(data);
  }, [licenseFeeInfo]);

  return (
    <>
      <ErrorModal
        open={isPaymentError}
        handleClose={handleModalClose}
        isPaymentError={isPaymentError}
        paymentErrorMessage={paymentErrorMessage}
        // TODO: Append the ability to retry the payment
        paymentCallback={() => { handleModalClose(); }}
      />
      <VerticalStepper activeStep={4}>
        <CheckoutForm
          onSuccess={handleSuccess}
          onSuccessRedirect={handleSuccessfulPayment}
          totalAmount={activePaymentMethodTab === CREDIT_CARD_TAB ? licenseFeeInfo.ccTotal : licenseFeeInfo.achTotal}
          checkoutDetails={checkoutDetails}
          paymentId={licenseFeeInfo.paymentId}
          licenseFeeInfo={licenseFeeInfo}
          paymentPayload={paymentPayload}
          setActivePaymentMethodTab={setActivePaymentMethodTab}
          activePaymentMethodTab={activePaymentMethodTab}
          setIsPaymentError={setIsPaymentError}
          setPaymentErrorMessage={setPaymentErrorMessage}
        />
      </VerticalStepper>
    </>
  );
}
